import classNames from "classnames";
import React from "react";
import { CategoryLabelMap } from "./meta/schema";
import styles from "./Tags.module.css";

export interface TagsProps {
  className?: string;
  tags: any;
  url: any;
}

const _Tags = ({ tags, url, className = "", ...props }: TagsProps) => {

  // Create a list of tags with their respective Category name.
  const tagList = Object.keys(tags)
    .map((key) => {
      const a = tags[key]?.map((v) => ({
        Category: key,
        TagName: v.TagName,
        CountryName: v.CountryName,
        Name: v.Name,
      }));
      return a;
    })
    .flat().filter(v => v);

  if (tagList?.length <= 0) return null;

  return (
    <div
      className={classNames(styles.tags, className, "animateonscroll")}
      {...props}
    >
      <h5>TAGS</h5>
      <div>
        { tagList?.length && tagList.map((tag, i) => (
          <a
            key={`${tag}-${i}`}
            className={styles.tag}
            href={
              url +
              `?${CategoryLabelMap[tag?.Category]}=${encodeURIComponent(
                tag?.Name?.toLowerCase() || tag?.CountryName?.toLowerCase()
              )}`
            }
            target="_blank"
            rel="noopener noreferrer"
            dangerouslySetInnerHTML={{ __html: tag?.TagName || tag?.CountryName || tag?.Name }}
          />
        ))}
      </div>
    </div>
  );
};

export const Tags = React.memo(_Tags);
